module.exports = __webpack_public_path__ + "img/9791187050469.97a331a7.jpg";